'use strict';

const _ = require('lodash');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');

module.exports = (input, config) => {
    _.defaults(config, {
        required: false,
    });
    const values = Object.assign({}, input);

    // max occurrencies check
    const choicesWithOccurrencies = config.choices.filter((c) => c.occurrencies > 0);
    if (choicesWithOccurrencies.length > 0) {
        choicesWithOccurrencies.forEach((cwo) => {
            const occurrencies = _.pickBy(values, (value) => value.includes(cwo.id));
            const occurrenciesRows = Object.keys(occurrencies);
            if (occurrenciesRows.length > cwo.occurrencies) {
                throw new ParserError(PARSER_ERRORS.MAX_OCCURRENCIES, [{errorRows: occurrenciesRows}]);
            }
        });
    }

    // min occurrencies check
    const choicesWithMinOccurrencies = config.choices.filter((c) => c.min > 0);
    let minOccurrenciesRows = [];
    if (choicesWithMinOccurrencies.length > 0) {
        choicesWithMinOccurrencies.forEach((cwo) => {
            const occurrencies = _.pickBy(values, (value) => value.includes(cwo.id));
            const occurrenciesRows = Object.keys(occurrencies);
            if (occurrenciesRows.length === 0) {
                minOccurrenciesRows = minOccurrenciesRows.concat(config.rows.map((row) => row.id));
            } else if (occurrenciesRows.length < cwo.min) {
                minOccurrenciesRows = minOccurrenciesRows.concat(occurrenciesRows);
            }
        });
        minOccurrenciesRows = _.uniq(minOccurrenciesRows);
    }
    if (minOccurrenciesRows.length > 0) {
        throw new ParserError(PARSER_ERRORS.MIN_OCCURRENCIES, [{errorRows: minOccurrenciesRows}]);
    }

    // min max answers for rows check
    _.forEach(Object.keys(values), (k) => {
        const rowConfig = _.find(config.rows, {id: k});
        if (_.isNumber(rowConfig.min) && values[k].length < rowConfig.min) {
            throw new ParserError(PARSER_ERRORS.MIN_CHOICES_ROW, [{errorRows: [k], min: rowConfig.min}]);
        }

        if (_.isNumber(rowConfig.max) && values[k].length > rowConfig.max) {
            throw new ParserError(PARSER_ERRORS.MAX_CHOICES_ROW, [{errorRows: [k], max: rowConfig.max}]);
        }
    });

    // min max rows answered check
    let choicesDone = Object.keys(values).filter((k) => (values[k].length > 0));
    if (_.isNumber(config.min) && choicesDone.length < config.min) {
        if (choicesDone.length === 0) {
            choicesDone = Object.keys(values);
        }
        throw new ParserError(PARSER_ERRORS.MIN_CHOICES, [{errorRows: choicesDone, min: config.min}]);
    }

    if (_.isNumber(config.max) && choicesDone.length > config.max) {
        throw new ParserError(PARSER_ERRORS.MAX_CHOICES, [{errorRows: choicesDone, max: config.max}]);
    }

    return values;
};
